import { Component } from '@angular/core';
import BaseQuestion from '../base-question';
import { FeedbackQuestionService } from '../feedback-question.service';
import { FeedbackQuestion } from "../../../common/models/feedback-question";
import { FeedbackBoolAnswerComponent } from "../../answers/bool";

@Component({
  selector: 'app-feedback-bool-question',
  templateUrl: 'feedback-bool-question.component.html',
  standalone: true,
  imports: [
    FeedbackBoolAnswerComponent
  ],
  styleUrls: ['./../feedback-question.css']
})
export class FeedbackBoolQuestionComponent extends BaseQuestion {
    public static type = FeedbackQuestion.TYPE_BOOL;

    constructor(feedbackQuestionService: FeedbackQuestionService) {
        super(feedbackQuestionService);
    }
}
